import AjaxService from 'Services/AjaxService';
import { has } from 'lodash';

const ORDER_DETAIL_ENDPOINT = '/order/{orderNumber}';

export default {
  async getOrderDetail({ commit }, { orderNumber }) {
    let result;
    try {
      const url = ORDER_DETAIL_ENDPOINT.replace(
        '{orderNumber}',
        orderNumber
      );
      result = await AjaxService.get(url);
    } catch (e) {
      return null;
    }
    if (
      has(result, 'data.order.orderHeader') &&
      has(result, 'data.order.orderRows')
    ) {
      // noinspection JSObjectNullOrUndefined
      const { orderHeader, orderRows } = result.data.order;
      const details = {
        ...converOrderHeaderToOrderDetails(orderHeader, orderRows),
      };

      commit('SET_ORDER_DETAIL', details);
      return details;
    }

    return null;
  },
  setOrderMap({ commit }, orders) {
    const orderMap = Array.isArray(orders)
      ? orders.reduce((ordersIndex, order) => {
          const orderNumber = order.orderNumber || order.order_number;

          if (!orderNumber) return ordersIndex;

          ordersIndex[orderNumber] = order;
          return ordersIndex;
        }, {})
      : orders;

    commit('SET_ORDER_MAP', orderMap);
  },
};
const converOrderHeaderToOrderDetails = (orderHeader, orderRows) => {
  return {
    ...orderHeader,
    amounts: orderHeader.totals,
    invoiceUrls: orderHeader.invoices,
    shippingAddressList: orderHeader.shippingAddresses,
    paymentList: orderHeader.payments,
    totalAmount: orderHeader.totals.paymentTotal,
    products: orderRows,
  };
};
